import { useState, useEffect } from 'react';
import { ArrowRight, Briefcase, MapPin, Clock, Users, Laptop, TrendingUp, Rocket } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const jobHighlights = [
  {
    icon: Users,
    title: 'Klein team',
    desc: 'Directe impact op projecten',
  },
  {
    icon: Laptop,
    title: 'Flexibel werk',
    desc: 'Hybride werken mogelijk',
  },
  {
    icon: TrendingUp,
    title: 'Groei',
    desc: 'Opleidingsbudget voorzien',
  },
  {
    icon: Rocket,
    title: 'Startup sfeer',
    desc: 'Dynamische werkomgeving',
  },
];

export default function Jobs() {
  const [vacatures, setVacatures] = useState([]);

  useEffect(() => {
    axios.get(`${API}/jobs`).then(r => setVacatures(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="jobs-page">
      <section className="relative pt-40 pb-24 overflow-hidden" style={{ background: 'linear-gradient(135deg, #16224b 0%, #233a80 58%, #f2a100 100%)' }}>
        <div className="dot-pattern absolute inset-0" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <h1 className="text-white font-bold tracking-tight mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.03em' }}>
            Bouw mee aan de toekomst
          </h1>
          <p className="text-white/70 max-w-xl mx-auto text-base leading-8">
            Word deel van een jong en gepassioneerd team dat bedrijven helpt met hun
            digitale transformatie. Ontdek onze openstaande vacatures.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {jobHighlights.map((item) => (
              <div key={item.title} className="admin-surface p-6 text-center">
                <div className="icon-container mx-auto mb-4">
                  <item.icon className="w-5 h-5" />
                </div>
                <h3 className="text-[#16224b] text-base font-bold mb-1">{item.title}</h3>
                <p className="text-[#6b7184] text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#f8f9fd]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <h2 className="text-[#16224b] font-bold mb-3" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.4rem)' }}>
              Openstaande Vacatures
            </h2>
            <p className="text-[#6b7184]">
              Bekijk onze huidige vacatures en vind de positie die bij je past.
            </p>
          </div>

          {vacatures.length === 0 ? (
            <div className="text-center py-20">
              <Briefcase className="w-16 h-16 text-gray-200 mx-auto mb-6" />
              <h3 className="text-[#16224b] text-xl font-bold mb-3">Geen openstaande vacatures</h3>
              <p className="text-[#6b7184] mb-8">
                Stuur gerust een open sollicitatie naar jobs@dgitaal.be
              </p>
              <a href="mailto:jobs@dgitaal.be" className="btn-gradient">
                Open sollicitatie <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          ) : (
            <div className="space-y-4">
              {vacatures.map((v, i) => (
                <div key={v.id || i} className="p-7 rounded-lg border border-gray-100 bg-white hover:shadow-xl hover:border-[#3d56a6]/20 transition-all duration-300">
                  <div>
                    <h3 className="text-[#16224b] font-bold text-lg mb-2">{v.titel}</h3>
                    <div className="flex items-center gap-4 text-xs text-[#6b7184]">
                      <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {v.locatie || 'Gent'}</span>
                      <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {v.type || 'Voltijds'}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-20 bg-white text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-[#16224b] font-bold mb-4" style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>
            Geen passende vacature?
          </h2>
          <p className="text-[#6b7184] mb-8">
            Stuur ons een open sollicitatie met je CV. We zijn altijd op zoek naar talent.
          </p>
          <a href="mailto:jobs@dgitaal.be" className="btn-gradient text-base px-10 py-4">
            Open Sollicitatie <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </section>
    </div>
  );
}
